<table mat-table class="mat-table-selection" [dataSource]="dataSource">

    <ng-container matColumnDef="noRecord">
        <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
            <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
        </td>
    </ng-container>

    <ng-container matColumnDef="hint">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.hint"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected': selectedId === transport.id}">
            <sc-flex>

                <app-transport-scope-icon [scope]="transport.transportScope" [type]="transport.transportType">
                </app-transport-scope-icon>

                <ng-container *ngIf="transport.useGlobalConnect">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-qrcode"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.useSms">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-message-sms"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.usePager">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-wifi"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.important">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-exclamation"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.urgent">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-truck-fast"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.intermitted">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.umbrueckung">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-shuffle"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.dangerousGoods">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.pendingTaskState !== PendingTaskState.NONE">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
                </ng-container>

            </sc-flex>
        </td>
    </ng-container>

    <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.carrier"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.carrier}} </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.supplier"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.supplier}} </td>
    </ng-container>

    <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.numberplate"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.identifier}} </td>
    </ng-container>

    <ng-container matColumnDef="driver">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.driver"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.driver}} </td>
    </ng-container>

    <ng-container matColumnDef="visitStatusDict">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.status"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}">
            <sc-dictionary-label dictionaryKey="tmc.transport-status.{{transport.status}}"></sc-dictionary-label>
        </td>
    </ng-container>

    <ng-container matColumnDef="string1">
        <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.string-1"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.string1}} </td>
    </ng-container>

    <ng-container matColumnDef="string2">
        <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.string-2"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.string2}} </td>
    </ng-container>

    <ng-container matColumnDef="start">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.start"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.start}} </td>
    </ng-container>

    <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.reference"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.reference}} </td>
    </ng-container>

    <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.options"></sc-dictionary-label>
        </th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}">
            {{transport.options}}
        </td>
    </ng-container>

    <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
        </th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.cargo}}
        </td>
    </ng-container>

    <ng-container matColumnDef="planningDate">
        <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planning-date"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.planningDate}} </td>
    </ng-container>

    <ng-container matColumnDef="messagingResources">
        <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging-resources"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.messagingResources}}
        </td>
    </ng-container>

    <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}"> &nbsp;</td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
        ></tr>

    <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
</table>
